import React from 'react'

import AuditText from 'components/audit/AuditText'
import AuditUser from 'components/audit/AuditUser'
import AuditWorkflow from 'components/audit/AuditWorkflow'

export const PROCESSED_WORKFLOWS_CONFIG = [
  {
    title: 'Timestamp',
    field: 'timestamp',
  },
  {
    title: 'Export type',
    render: ({ leadType }) => leadType,
  },
  {
    title: 'Source',
    render: ({ source }) => source,
  },
  {
    title: 'Lead UUID',
    render: ({ lead }) => lead?.uuid,
  },
]

export const UNPROCESSED_WORKFLOWS_CONFIG = [
  ...PROCESSED_WORKFLOWS_CONFIG,
  {
    title: 'Error',
    render: ({ error }) => error,
  },
]

export const EMAIL_CONFIG = [
  {
    title: 'Timestamp',
    field: 'timestamp',
  },
  {
    title: 'Type',
    render: ({ payload }) => payload.type,
  },
  {
    title: 'Subject',
    render: ({ payload }) => <AuditText text={payload.subject} />,
  },
  {
    title: 'User',
    render: ({ meta }) => <AuditUser userId={meta.userId} />,
  },
  {
    title: 'Workflow',
    render: ({ meta }) => <AuditWorkflow workflowId={meta.workflowId} />,
  },
]

export const PROCESSED_SIGNALS_CONFIG = [
  {
    title: 'Timestamp',
    field: 'timestamp',
  },
  {
    title: 'Export type',
    render: ({ leadType }) => leadType,
  },
  {
    title: 'Source',
    render: ({ source }) => source,
  },
]

export const UNPROCESSED_SIGNALS_CONFIG = [
  ...PROCESSED_SIGNALS_CONFIG,
  {
    title: 'Error',
    render: ({ error }) => error,
  },
]
